"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
require("cn-next/es/button/style");
var _button = _interopRequireDefault(require("cn-next/es/button"));
var _react = _interopRequireDefault(require("react"));
var footer = [{
  text: '全选',
  type: 'all'
}, {
  text: '反选',
  type: 'reverse'
}, {
  text: '清空',
  type: 'clear'
}];
var _default = function _default(props) {
  var locale = props.locale,
    count = props.count,
    _props$onChoose = props.onChoose,
    onChoose = _props$onChoose === void 0 ? function () {} : _props$onChoose;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "cn-address-footer"
  }, Array(count).fill(0).map(function (i, index) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "cn-address-footer-item",
      key: i
    }, footer.map(function (btn) {
      return /*#__PURE__*/_react["default"].createElement(_button["default"], {
        key: btn.type,
        onClick: function onClick() {
          return onChoose(index, btn.type);
        }
        // disabled={apiModel === 'cdn' && maxLevel > 3 && index === 0 && btn.type !== 'clear'}
        ,
        className: "cn-address-footer-btn"
      }, locale[btn.type]);
    }));
  }));
};
exports["default"] = _default;
module.exports = exports.default;
module.exports.default = exports.default;